import * as types from './types'

export function updateUser( user ) {
	return {
		type: types.USER_INFO,
		payload: user
	}
}